import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IAccountDetailsResponse } from "@miplatform/types";

export const useCustomerPricingDetailsViewModel = () => {
  const [accountDetails, setAccountDetails] =
    useState<IAccountDetailsResponse | null>(null);

  const stateManager = useComponentState();

  const getAccountDetails = (id: string) => {
    return stateManager.run(async () => {
      const response = await accountService.accounts.getAccountById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setAccountDetails(response.data);
      }
      return response;
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    stateManager,
    accountDetails,
    getAccountDetails,
  };
};
